hrd.AbstractCustomRichHomeDashboard = hrd.AbstractDashboard.extend({
	init: function(options) {
		const defaults = {
			impl: 'hrd.AbstractCustomRichHomeDashboard',
		};
		this._super($.extend({}, defaults, options));
	},
	extractItemData: function() {
		let contextData = {};
		let qs = document.location.search;
		if (qs != undefined && qs.indexOf('?') == 0) {
			let params = $.String.deparam(qs.substring(1));
			if (params.itemData != undefined) {
				contextData.itemData = JSON.parse(this.toolbox.atou(params.itemData));
			}
			if (params.groupData != undefined) {
				contextData.groupData = params.groupData;
			}
		}
		return contextData;
	},
	visit: function() {
		let contextData = this.extractItemData();
		const group = contextData.groupData;
		const item = contextData.itemData;
		const targetUri = `${hrd.globals.contextRoot}${item.link}`;

		switch (item.type) {
			case 'POPUP':
				hrd.utils.executeTopFunction('navManager.openPopup', 'navManager', [targetUri, item.label]);
				break;
			case 'CRUD_POPUP':
				let cb = undefined;
				hrd.utils.executeTopFunction('navManager.openCRUDPopup', 'navManager', [targetUri, item.label, undefined, cb]);
				break;
			case 'CUSTOM_FN':
				hrd.utils.executeTopFunction(item.customFn, undefined, item.customFnArgs);
				break;
			default:
				hrd.utils.hpLink(targetUri);
				dashboardInstance.intercom.emit('menu-change-page', { clickedGroupId: group.group, clickedItem: item });
				break;
		}
	},
});